import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './DeviceUpgradeSpecification.Styles';

const DeviceUpgradeSpecification = ({
  specifications,
  boxContent,
  fullSpecifications,
  onDeviceFullSpecsPress,
}) => {
  const theme = useTheme();
  const Images = getThemeImages(theme?.name);
  return (
    <View style={styles.container}>
      <View style={styles.firstSection}>
        {_map(specifications, (option, index) => {
          return (
            <View key={`${index}`} style={styles.sectionItem}>
              <VFText i18nKey={option.name} style={styles.sectionName} />
              {_map(option.values, (optionValue, optionValueindex) => {
                return (
                  <VFText
                    key={`${optionValueindex}`}
                    i18nKey={optionValue}
                    style={styles.sectionItemValues}
                  />
                );
              })}
              {_map(option.extraFeatures, (optionExtraFeature, optionExtraFeatureindex) => {
                return (
                  <VFText
                    key={`${optionExtraFeatureindex}`}
                    i18nKey={optionExtraFeature}
                    style={styles.sectionItemExtraFeatures}
                  />
                );
              })}
            </View>
          );
        })}
      </View>
      <View style={styles.separator(theme)} />
      <View style={styles.secondSection}>
        <VFText style={styles.inBoxTitle} i18nKey={'device_upgrade_device_step_in_box'} />
        {_map(boxContent, (option, index) => {
          return <VFText key={`${index}`} i18nKey={option} style={styles.inBoxItem} />;
        })}
      </View>
      {fullSpecifications?.length > 0 && (
        <TouchableOpacity
          onPress={() => onDeviceFullSpecsPress(fullSpecifications)}
          style={styles.fullSpecsBtnStyle(theme)}
        >
          <VFText
            i18nKey={'device_upgrade_device_step_show_full_specifications_button_title'}
            style={styles.fullSpecsBtnTextStyle(theme)}
          />
          <Icon
            name={Images.ic_chevron_right_red}
            type={'image'}
            size={25}
            style={styles.iconStyle}
          />
        </TouchableOpacity>
      )}
    </View>
  );
};
DeviceUpgradeSpecification.propTypes = {
  specifications: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(PropTypes.string.isRequired),
      extraFeatures: PropTypes.arrayOf(PropTypes.string.isRequired),
    }),
  ),
  fullSpecifications: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(PropTypes.string.isRequired),
    }),
  ),
  onDeviceFullSpecsPress: PropTypes.func,
  boxContent: PropTypes.arrayOf(PropTypes.string.isRequired),
};
export default DeviceUpgradeSpecification;
